import React from "react";

export default function TermsAndConditions() {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Terms & Conditions</h1>

      <p style={styles.updated}>Last updated: {new Date().toLocaleDateString()}</p>

      <section style={styles.section}>
        <h3>1. General</h3>
        <p>
          By using this application and placing an order, you agree to comply
          with and be bound by the following Terms & Conditions. These terms
          apply to all users of the platform.
        </p>
      </section>

      <section style={styles.section}>
        <h3>2. Prescription Medicines</h3>
        <p>
          Prescription medicines may require a valid prescription. Prescription
          medicines sourced directly from hospitals are non-returnable after
          dispatch, as per hospital and regulatory policies.
        </p>
      </section>

      <section style={styles.section}>
        <h3>3. Orders & Cancellation</h3>
        <ul>
          <li>Orders can be cancelled only before dispatch.</li>
          <li>
            Once an order is marked <strong>Out for Delivery</strong>,
            cancellation or refusal may incur delivery charges.
          </li>
          <li>Orders marked as delivered cannot be cancelled.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h3>4. Cash on Delivery (COD)</h3>
        <ul>
          <li>COD is available only for eligible products.</li>
          <li>
            In case of refusal or failed delivery, delivery charges are
            non-refundable.
          </li>
          <li>
            Repeated COD refusals may result in restriction of COD service.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h3>5. Delivery</h3>
        <p>
          Delivery times are estimates and may vary due to traffic, weather,
          availability, or other unforeseen factors. Delivery charges, once
          applied, are non-refundable.
        </p>
      </section>

      <section style={styles.section}>
        <h3>6. Payments</h3>
        <p>
          Online payments are securely processed via authorized payment gateways.
          In case of payment failure, the order may not be confirmed.
        </p>
      </section>

      <section style={styles.section}>
  <h3>7. Liability & User Responsibility</h3>
  <p>
    By using this platform and purchasing medicines, you acknowledge and agree
    that all medicines are consumed strictly at your own risk. The platform acts
    solely as an intermediary facilitating access to pharmacies, hospitals, and
    sellers.
  </p>

  <p>
    The platform does not provide medical advice, diagnosis, or treatment. Users
    are strongly advised to consult a qualified medical practitioner before
    consuming any medicine.
  </p>

  <p>
    The platform shall not be held responsible or liable for any adverse effects,
    misuse, incorrect dosage, allergic reactions, or health complications
    arising from the use of medicines ordered through the platform.
  </p>

  <p>
    By placing an order, you confirm that you understand the risks involved and
    take full responsibility for the usage of the products. The platform bears
    no liability for any direct, indirect, incidental, or consequential damages
    resulting from such use.
  </p>
</section>

      <section style={styles.section}>
        <h3>8. Jurisdiction</h3>
        <p>
          These Terms & Conditions shall be governed by and construed in
          accordance with the laws of India.
        </p>
      </section>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "auto",
    padding: "20px 15px",
    lineHeight: 1.8,
    background: "#f9fafb",
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    marginBottom: 10,
    fontSize: "22px",
    fontWeight: "bold",
  },
  updated: {
    textAlign: "center",
    fontSize: 12,
    color: "#666",
    marginBottom: 20,
  },
  section: {
    marginBottom: 20,
    background: "#fff",
    padding: 15,
    borderRadius: 10,
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
};
